<template>
  <v-app class="container_tabledata" color="#fff">
    <v-card class="rounded-0 elevation-0" elevation="0">
      <v-layout v-resize="onResize" column style="">
        <loadingTable v-if="!snapshotData" />
        <v-card
          v-if="snapshotData"
          class="ma-3 elevation-0 rounded-0"
          style="border: solid 1px #e0e0e0"
        >
          <v-toolbar elevation="0" class="pa-0" color="#F7F7F7" fixed dense>
            <v-menu offset-y content-class="elevation-0 rounded-0 pa-0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  style="border: solid 1px #e0e0e0"
                  small
                  class="rounded-0 pa-1 elevation-0 ma-0"
                  color="#ffff"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ kFormatter(itemsPerPage)
                  }}<v-icon small style="margin-left: 0.2em"
                    >mdi-unfold-more-horizontal</v-icon
                  >
                </v-btn>
              </template>
              <v-list style="border: solid 1px #e0e0e0">
                <v-list-item @click="itemsPerPage = 10"
                  ><v-list-item-title>10</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = 25"
                  ><v-list-item-title>25</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = 15"
                  ><v-list-item-title>50</v-list-item-title></v-list-item
                >
                <v-list-item @click="itemsPerPage = reportsData.length"
                  ><v-list-item-title>100</v-list-item-title></v-list-item
                >
              </v-list>
            </v-menu>
            <v-spacer style="width: 70%"></v-spacer>
            <v-text-field
              style="border: solid 1px #e0e0e0"
              width="40"
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              placeholder="Search"
              solo
              clearable
              class="elevation-0 rounded-0"
              @click="nulsearch()"
            ></v-text-field>
          </v-toolbar>
          <v-divider></v-divider>
          <v-data-table
            style="margin-top: 0px"
            v-if="snapshotData"
            :search="search"
            :headers="headers"
            :items="snapshotData"
            :items-per-page="itemsPerPage"
            hide-default-footer
            hide-default-header
            :page.sync="page"
            class="elevation-0 rounded-0 dataTable desktopTable_snapshot"
            @page-count="pageCount = $event"
            @pagination="yourMethod"
          >
            <template v-slot:header>
              <th
                class="pa-0 pt-2 pl-1"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                "
              >
                No
              </th>
              <th
                class="pa-0 pt-2 pl-1"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                "
              >
                Vessel Name
              </th>
              <th
                class="pa-0 pt-2 pl-1"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                "
              >
                Company
              </th>
              <th
                class="pa-0 pt-2 pl-1"
                style="
                  text-align: left;
                  color: #626364;
                  font-size: 0.9em;
                  height: 3em;
                "
              ></th>
            </template>
            <template v-slot:item="row">
              <tr>
                <td
                  width="8%"
                  class="pa-1"
                  style="white-space: nowrap; min-width: 2.5em"
                >
                  {{ row.item.index + 1 }}
                </td>
                <td width="30%" class="pa-1" style="white-space: nowrap">
                  {{ row.item.name }}
                </td>
                <td width="32%" class="pa-1" style="white-space: nowrap">
                  {{ row.item.pt_name }}
                </td>
                <td width="30%" class="pa-1" style="white-space: nowrap">
                  <v-btn
                    width="98%"
                    dark
                    class="elevation-0 rounded-0 pa-1"
                    color="primary"
                    @click="showsnapshotFolder(row.item)"
                    small
                    >Show
                    Snapshot</v-btn
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-data-table
          style="margin-top: 0px"
            v-if="snapshotData"
            :search="search"
            :headers="headers"
            :items="snapshotData"
            :items-per-page="itemsPerPage"
            hide-default-footer
            hide-default-header
            :page.sync="page"
            class="elevation-0 rounded-0 mobileTable_snapshot "
            @page-count="pageCount = $event"
            @pagination="yourMethod"
          ><template v-slot:item="row">
    
      <tr style="margin-top:0.4em;margin-bottom:0.4em" >
        <td style="border-bottom:none;text-align:center" >
        <v-card style="border: solid 1px #e0e0e0" class="elevation-0 rounded-0 ma-1" width="87vw">
          <v-toolbar
           dense
           class="elevation-0 rounded-0"
          >
            <v-toolbar-subtitle>{{row.item.index+1}}</v-toolbar-subtitle>
            <v-spacer></v-spacer>
           
                

          </v-toolbar>
          <v-divider></v-divider>
      <v-card-text>
              <table>
           
            <tr><td>Vessel Name</td><td>:</td><td>{{row.item.name}}</td></tr>
            <tr><td>Company</td><td>:</td><td>{{row.item.pt_name}}</td></tr>
            <tr><td colspan="3"><v-divider></v-divider></td></tr>
            <tr><td  colspan="3" class="pa-1"> <v-btn
                   
                    dark
                    class="elevation-0 rounded-0 pa-1"
                    color="primary"
                    @click="showsnapshotFolder(row.item)"
                    small
                    >Show
                    Snapshot</v-btn
                  ></td></tr>
       
        
            
          </table>
            </v-card-text>
          </v-card>
          
          
          
        </td>
      </tr>
   
  </template></v-data-table>
          <v-divider></v-divider>
          <v-toolbar dense class="elevation-0 rounded-0" color="#f7f7f7">
            <p class="mt-3" style="font-size: 0.8em">
              Showing {{ showingDatafrom }} to {{ showingDatato }} of
              {{ totalFilter }} entries
            </p>

            <v-spacer></v-spacer>
            <v-pagination
              color="primary"
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-toolbar>
        </v-card>
      </v-layout>
      <div id="bottom_table_snapshot"></div>
    </v-card>
    <ShowSnapshotSkeleton v-if="!loadingfolder && snapshotclick"/>
    <ShowSnapshot v-if="loadingfolder" />
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import $ from "jquery";
import loadingTable from "@/components/progress/loadingTable.vue";
import ShowSnapshot from "@/components/showpage/ShowSnapshot.vue";
import ShowSnapshotSkeleton from "@/components/skeleton/ShowSnapshotSkeleton.vue";
export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  components: {
    loadingTable,
    ShowSnapshot,
    ShowSnapshotSkeleton,
  },
  data() {
    return {
      totalFilter: null,
      showpictonclick: null,
      action: null,
      folderOnSelect: null,
      filter_btn_clicked: null,
      display: "none",
      itemsPerPage: 10,
      page: 1,
      pageCount: 0,
      itemsPerPageImage: 25,
      pageImage: 1,
      pageCountImage: 0,
      itemsPerPageFolders: 25,
      pageFolders: 1,
      pageCountFolders: 0,
      pageSize: 1,
      showpict: null,
      listCount: 0,
      snapshotpict_: [],
      headers: [
        {
          text: "No",
          align: "start",
          sortable: false,
          value: "id",
        },
        { text: "Vessel Name", value: "name", sortable: false },
        { text: "Company", value: "pt_name", sortable: false },
        { text: "Show Snapshot", value: "", sortable: false },
      ],
      skeleton_data: [
        { data: "" },
        { data: "" },
        { data: "" },
        { data: "" },
        { data: "" },
        { data: "" },
        { data: "" },
        { data: "" },
      ],
      // in real case initial search_result = [], and methods: search function inject below data
      snapshot: null,
      imageOpen: null,
      imageData: null,
      search: "",
      loadernavplus: require("@/assets/img/load100new.gif"),
      folderclose: require("@/assets/img/close-folder.png"),
      folderloading: require("@/assets/img/loading-folder.png"),
      foldercloseagain: require("@/assets/img/close-folder.png"),
      folderopen: require("@/assets/img/open-folder.png"),
    };
  },
  created() {
    this.fetchSnapshot(localStorage.getItem("token"));
  },
  methods: {
    ...mapActions([
      "addsnapshot_executed",
      "closeShow",
      "fetchSnapshot",
      "snapshotFolder",
      "showSnapshot_",
      "FolderClick",
      "vesselDataSet",
      "FilterClick",
    ]),

    yourMethod(pagination) {
      this.totalFilter = pagination.itemsLength;
    },

    async showsnapshotFolder(item) {
      this.addsnapshot_executed(false)
      console.log(this.snapshot_executed)
      console.log("SHOW SNAPSHOT FOLDER");
      $("html, body").animate(
        {
          scrollTop: $("#bottom_table_snapshot").offset().top,
        },
        1000
      );

      const data = {
        id: item.id,
        token: localStorage.getItem("token"),
      };

      this.vesselDataSet(item);
      this.snapshotFolder(data);

      console.log(this.folderSelect);
    },

    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
        : Math.sign(num) * Math.abs(num);
    },




  },
  computed: {
    ...mapGetters([
      "folderSelect",
      "filterList",
      "snapshotData",
      "snapshotpict",
      "snapshotfolder",
      "loadingimage",
      "loadingfolder",
      "vesselData",
      "snapshotclick",
      "snapshot_executed"
    ]),
    pages() {
      if (this.pageSize == null || this.listCount == null) return 0;
      return Math.ceil(this.listCount / this.pageSize);
    },

    showingDatafrom() {
      if (this.totalFilter < 1) {
        return 0;
      } else {
        return 1;
      }
    },

    showingDatato() {
      if (this.totalFilter < this.itemsPerPage) {
        return this.totalFilter;
      } else {
        return this.itemsPerPage;
      }
    },

    target() {
      return 82000000;
    },
    options() {
      return {
        duration: 300,
        offset: 0,
        easing: "easeInOutCubic",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.margintab {
  margin-top: -25px;
}

.bxfile {
  font-size: 40px;
}

.imgsnapshot {
  width: 150px;
  margin: 10px;
}

.datasnapshot {
  top: 70px;
}



@media (min-width: 280px) and (max-width: 319px) {
  .mobileTable_snapshot{
    display:block
  }
  .desktopTable_snapshot{
    display:none
  }
}

/* Mobile Devices */
@media (min-width: 320px) and (max-width: 480px) {
  .mobileTable_snapshot{
    display:block
  }
  .desktopTable_snapshot{
    display:none
  }
}

/* iPads, Tablets */
@media (min-width: 481px) and (max-width: 768px) {
  .mobileTable_snapshot{
    display:none
  }
  .desktopTable_snapshot{
    display:block
  }
}

/* Small screens, laptops */
@media (min-width: 769px) and (max-width: 1024px) {
  .mobileTable_snapshot{
    display:none
  }
  .desktopTable_snapshot{
    display:block
  }
}

/* Desktops, large screens */
@media (min-width: 1025px) and (max-width: 1200px){
  .mobileTable_snapshot{
    display:none
  }
  .desktopTable_snapshot{
    display:block
  }
}

/* Extra large screens / TV */
@media screen and (min-width: 1201px) {
  .mobileTable_snapshot{
    display:none
  }
  .desktopTable_snapshot{
    display:block
  }


}
</style>
